
export class ManageCredentialsModel{
  credentialID:any;
  projectID:any;
  isLive:any;
  projectURL:any;
  userType:any;
  userName:any
  password:any; 
}